import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject, Injector } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { ToastrService } from '../services/toastr.service';

export const errorLogInterceptor: HttpInterceptorFn = (req, next) => {
  const injector = inject(Injector);

  const exceptedEndPoints: string[] = [
    'infoLinkByName',
    'checkMfaVerificationCode'
  ];

  const noNeedInterceptor = exceptedEndPoints.find(endPoint => {
    return req.url.includes(endPoint);
  });

  if (noNeedInterceptor) {
    return next(req);
  }

  return next(req).pipe(
    catchError((err: HttpErrorResponse) => {
      // login need Verify Otp Code
      if (req.url.includes('loginClient') && err.status == 400) {
        return throwError(() => err);
      }

      const toastrService = injector.get(ToastrService);

      if (err.status == 500) {
        toastrService.error('An error occurred!');
      } else {
        handleErrorResponse(err, toastrService);
      }
      return throwError(() => err);
    })
  );
};

function handleErrorResponse(err: HttpErrorResponse, toastrService: ToastrService) {
  if (err.error instanceof Blob) {
    const reader = new FileReader();
    reader.onload = () => {
      try {
        const jsonData = JSON.parse(reader.result as string);
        const errorMessage = getErrorMessage(jsonData);
        toastrService.error(errorMessage);
      } catch (e) {
        console.error('Failed to parse blob error response:', e);
        toastrService.error('An error occurred while processing the response');
      }
    };
    reader.readAsText(err.error);
  } else {
    const errorMessage = getErrorMessage(err);
    toastrService.error(errorMessage);
  }
}

function getErrorMessage(err: HttpErrorResponse | any): string {
  return getFirstValidationErrorFromErrors(err.error?.errors || err?.errors || {}) ||
    err?.error?.error?.message ||
    err?.error?.error ||
    err?.error?.message ||
    err?.message ||
    err?.error ||
    err;
}

function getFirstValidationErrorFromErrors(errors: any): string | null {
  const keys = Object.keys(errors);
  if (!keys.length) {
    return null;
  }
  return errors[keys[0]][0];
}
